import Model from 'flarum/common/Model';
export default class ArenaCard extends Model {
  name() {
    return Model.attribute('name').call(this);
  }
  description() {
    return Model.attribute('description').call(this);
  }
  imageUrl() {
    return Model.attribute('imageUrl').call(this);
  }
  element() {
    return Model.attribute('element').call(this);
  }
  attack() {
    return Model.attribute('attack').call(this);
  }
  defense() {
    return Model.attribute('defense').call(this);
  }
  cost() {
    return Model.attribute('cost').call(this);
  }
  order() {
    return Model.attribute('order').call(this);
  }

  // Block 2 fields
  cardType() {
    var _Model$attribute$call;
    return (_Model$attribute$call = Model.attribute('cardType').call(this)) != null ? _Model$attribute$call : 'elemental';
  }
  bonusEffect() {
    return Model.attribute('bonusEffect').call(this);
  }
  bonusValue() {
    return Model.attribute('bonusValue').call(this);
  }
  isActive() {
    var _Model$attribute$call2;
    return (_Model$attribute$call2 = Model.attribute('isActive').call(this)) != null ? _Model$attribute$call2 : true;
  }
  isPublic() {
    var _Model$attribute$call3;
    return (_Model$attribute$call3 = Model.attribute('isPublic').call(this)) != null ? _Model$attribute$call3 : true;
  }
  isBonus() {
    return this.cardType() === 'bonus';
  }
}
flarum.reg.add('forumaker-arena', 'common/models/ArenaCard', ArenaCard);